import { useQuery } from '@tanstack/react-query';
import rawBankTransactionsApi from '@/features/dashboard/rawBankTransactions/api/rawBankTransactionsApi.ts';
import { rawBankTransactionsApiQueryKeys } from '@/features/dashboard/rawBankTransactions/api/rawBankTransactionsApi.queryKeys.ts';
import { SupportedBankDto } from '@/features/dashboard/rawBankTransactions/types/SupportedBankDto.ts';

export default function useGetSupportedBanks() {
  return useQuery<SupportedBankDto[]>({
    queryKey: rawBankTransactionsApiQueryKeys.supportedBanks(),
    queryFn: () => rawBankTransactionsApi.getSupportedBanks(),
    staleTime: 1000 * 60 * 60,
  });
}
